import Operation, { configureOperationClasses } from "components/organisms/editor/core/model/lib/operation/base";
import NoOperation from "components/organisms/editor/core/model/lib/operation/no_operation";
import AddFileOperation from "components/organisms/editor/core/model/lib/operation/add_file_operation";
import MoveFileOperation from "components/organisms/editor/core/model/lib/operation/move_file_operation";
import EditFileOperation from "components/organisms/editor/core/model/lib/operation/edit_file_operation";
import SetFileMetadataOperation from "components/organisms/editor/core/model/lib/operation/set_file_metadata_operation";

configureOperationClasses({
    NoOperation,
    AddFileOperation,
    MoveFileOperation,
    EditFileOperation,
    SetFileMetadataOperation,
});

export default Operation;
